import type * as React from 'react';

import { DOMText } from '@gitbook/react-uikit';
import type { SelectionProps } from '@gitbook/slate-react';

import { getRealTimeColor } from '../../Users';
import type { RealtimeRangeData } from './types';

/**
 * Highlight a participant's selection.
 */
export function RealtimeSelectionRange(props: SelectionProps): React.ReactElement | null {
    const { children, selection } = props;
    const selectionData = selection.data.toFrozenObject<RealtimeRangeData>();
    const color = getRealTimeColor(selectionData.userId);

    // Don't render realtime selections in tests as it can be unpredictable
    if (process.env.GITBOOK_PREDICTABLE_UI) {
        return null;
    }

    return <DOMText style={[{ backgroundColor: color.faded }]}>{children}</DOMText>;
}
